import { Component } from 'react'
import { SingleDatePicker } from '@retailer-platform/shared-components/src/tds'
import moment, { type Moment } from 'moment'

interface ShiftsSingleDatePickerProps {
  isOutsideRange: (day: Moment) => boolean
  date: string
  onDateChange: (date: moment.Moment | null) => void
}

export class ShiftsSingleDatePicker extends Component<ShiftsSingleDatePickerProps> {
  static defaultProps = {
    isOutsideRange: () => false,
  }

  onFocusChange = ({ focused }) => {
    this.setState({ focused })
  }

  render() {
    const { isOutsideRange, date, onDateChange } = this.props

    return (
      <SingleDatePicker
        value={moment(date).toDate()}
        onChange={date => {
          if (!date) return
          onDateChange(moment(date))
        }}
        calendarProps={{
          excludeDate: date => isOutsideRange(moment(date)),
          firstDayOfWeek: 0, // Sunday
        }}
        label=""
        maxWidthPx={150}
      />
    )
  }
}
